import { config } from '../../config';
import { Store } from './types/Store';

/** The `window` property holding every exposed store, keyed by its id. */
export const EXPOSED_STORES_KEY = '__consumerPortalStores';

/**
 * Publishes a store on `window.__consumerPortalStores` under its id, outside
 * production, so the e2e suite can watch and set state the page does not show
 * (`apps/ui-e2e/src/support/storeRecorder.ts`). See this directory's README.
 */
export const exposeStore = <T>(
  id: string,
  store: Store<T>,
  enabled: boolean = config.debug.exposeStores,
): void => {
  if (!enabled) {
    return;
  }

  const page = window as unknown as Record<
    string,
    Record<string, Store<unknown>> | undefined
  >;

  page[EXPOSED_STORES_KEY] ??= {};
  page[EXPOSED_STORES_KEY][id] = store as unknown as Store<unknown>;
};
